/* eslint-disable */

const getters = {
  listProducts: state => state.listProducts || [],
};

export default getters;
